import React from 'react';
import { Avatar as MuiAvatar, Typography } from '@mui/material';

const stringToColor = string => {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Generate more muted, accessible colors
  // Use HSL for better control over saturation and lightness
  const hue = Math.abs(hash) % 360;

  // Keep saturation moderate (30-70%) to avoid too vivid colors
  const saturation = 30 + (Math.abs(hash >> 8) % 40);

  // Keep lightness in a range that ensures good contrast with white text
  // Lightness between 25-65% provides good contrast ratios
  const lightness = 25 + (Math.abs(hash >> 16) % 40);

  // Convert HSL to hex
  const hslToHex = (h, s, l) => {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = n => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, '0');
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  };

  return hslToHex(hue, saturation, lightness);
};

function Avatar({ name, sx = {}, alt = name, ...props }) {
  return (
    <MuiAvatar {...props} sx={{ backgroundColor: stringToColor(name), ...sx }} alt={alt}>
      <Typography>
        {name
          .split(' ')
          .slice(0, 2)
          .map(word => word[0])
          .join('')
          .toUpperCase()}
      </Typography>
    </MuiAvatar>
  );
}

export default Avatar;
